import { Column } from 'react-table';

const VenueTypeTableColumnConfig: Column[] = [
    {
        Header: 'Id',
        accessor: 'id',
        disableSortBy: false,
    },
    {
        Header: 'Name',
        accessor: 'name',
        disableSortBy: false,
    },
];

export default VenueTypeTableColumnConfig;

export const DefaultVisibleVenueTypeColumns = ['id', 'name'];

export const SearchableVenueTypeTableColumnConfig = ['id', 'name'];
